import { useCallback, useEffect, useRef, useState } from 'react'

export const useGetContainerContentHeightByOffset = (offset: number = 0) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const target = containerRef.current
  const [contentHeight, setContentHeight] = useState('100%')

  const handleResize = useCallback(() => {
    if (target) {
      const offsetHeight = containerRef?.current?.offsetHeight
      if (offsetHeight) {
        setContentHeight(`${offsetHeight - offset}px`)
      }
    }
  }, [offset, target])

  useEffect(() => {
    window.addEventListener('resize', handleResize)

    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [handleResize, offset])

  useEffect(() => {
    const handleIntersection = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          handleResize()
        }
      })
    }

    const observer = new IntersectionObserver(handleIntersection, { threshold: 0.5 })

    if (target) {
      observer.observe(target as Element)
    }

    return () => {
      if (target) observer.unobserve(target as Element)
    }
  }, [handleResize, target])

  return { containerRef, contentHeight }
}
